import React, { useState, useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { AircraftFilter } from './AircraftFilter';
import EventTypeFilter from './EventTypeFilter';
import StationFilter from './StationFilter';
import OtsStartDateFilter from './OtsStartDateFilter';
import ATACodeFilter from './AtaCodeFilter';
import FilterNavButtons from './FilterNavButtons';
import './FilterNavigation.scss';
import './FilterDrawer.scss';
import { ClosedParamsErrorState, ClosedSearchParams } from '../../../Models/ClosedSearchParams';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useEventType } from '../../../providers/EventTypeProvider';
import SearchFilter from './SearchFilter';
import FleetTypeFilter from './FleetTypeFilter';


const drawerWidth = 'calc(50%)';

interface FilterModalProps {
    open: boolean;
    onClose: () => void;
    searchParams: ClosedSearchParams;  
    handleInputChange: (field: keyof ClosedSearchParams) => (value: string | string[]) => void;
    handleErrorState: (field: keyof ClosedParamsErrorState) => (value: boolean) => void;
    onClearAll: () => void;
    onSearch: () => void;
    isDisabledSearch: boolean;
    isDisabledClear: boolean;
    errorState: ClosedParamsErrorState;
}


const ClosedFilterModal: React.FC<FilterModalProps> = ({ 
  open, 
  onClose,
  searchParams,
  handleInputChange,
  handleErrorState,
  onClearAll,
  onSearch,
  isDisabledSearch,
  isDisabledClear,
  errorState
}) => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const handleSearchAndClose = () => {
      onSearch();
      onClose();
  };
    const {eventTypes} = useEventType();

    useEffect(() => {
        const updatePaginationWidth = () => {
          const dashboardContainer = document.querySelector('.closed-dashboard-container.drawer-open');
          const paginationBlock = document.querySelector('.pagination_block') as HTMLElement;
          const body = document.querySelector('body');
      
          if (dashboardContainer && paginationBlock) {
            if (paginationBlock) {
              paginationBlock.style.width = 'calc(50% - 72px)';
            }
            if(body) {
              body.style.overflow = 'hidden';
            }

          } else {
            if (paginationBlock) {
              paginationBlock.style.width = '';
            }
            if(body) {
              body.style.overflow = 'auto';
            }
          }
        };
      
        updatePaginationWidth();
      
        const containerObserver = new MutationObserver(updatePaginationWidth);

        const domObserver = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
              updatePaginationWidth();
            }
          });
        });
        const container = document.querySelector('.closed-dashboard-container');
        
        if (container) {
          containerObserver.observe(container, {
            attributes: true,
            attributeFilter: ['class']
          });
    
          domObserver.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      
        window.addEventListener('resize', updatePaginationWidth);
      
        return () => {
          window.removeEventListener('resize', updatePaginationWidth);
          containerObserver.disconnect();
          domObserver.disconnect();
        };
      }, []);

      
    return (
        <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: drawerWidth,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'hidden',
            overflowX: 'hidden',
          },
        }}
        variant="persistent"
        slotProps={{
          backdrop: { invisible: true }
        }}
        >
            <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
            <div className="filter-drawer-top" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <div className='filter-header-text'>Filter by</div>
    <IconButton
      aria-label="close"
      onClick={onClose}
      size="large"
      sx={{
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </div>

                <div className="filter-group">
                   <div className="group-1">
                            <SearchFilter
                    searchFilterValue={searchParams.problemText}
                    onSearchFilterValueChange={handleInputChange('problemText')}/>                      
                    
                        </div>
                        
                        <div className="group-2">
                          <FleetTypeFilter 
                            fleetTypeValue={searchParams.fleetType}
                            onFleetTypeChange={handleInputChange('fleetType')}
                            onFleetTypeError={handleErrorState('isFleetTypeError')}
                            error={errorState.isFleetTypeError}>
                          </FleetTypeFilter> 
                            <ATACodeFilter
                                ataCode={searchParams.ataCode}
                                onATACodeChange={handleInputChange('ataCode')}
                                OnATACodeError={handleErrorState('isATAError')}
                                error={errorState.isATAError}
                            />
                        </div>
                  
                       
                </div>
                <div className="event-type-filter-group">
                    <EventTypeFilter
                        eventTypes={eventTypes.map((eventType) => eventType.Name)}
                        checkedEventTypes={searchParams.eventType}
                        onEventTypeFilterChange={handleInputChange('eventType')}
                    />  
                </div>
            </Box>

            <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: 'background.paper', padding: '12px 32px', height: '75px' }}>
            <div className="drawer-footer-btns">
            <FilterNavButtons.DrawerFooterButtons
                onClearAll={onClearAll}
                onSearch={handleSearchAndClose}
                isDisabledSearch={isDisabledSearch}
                isDisabledClear={isDisabledClear}
                footerClass="filter-drawer-btns"
                />
            </div>
            </Box>
        </Drawer>
    );
};

export default ClosedFilterModal;
